import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import $ from 'jquery';
import Env from '../model/Env';

class ContactForm extends Component {

    sendToApi(e){
        e.preventDefault();

        let fullname = $("#fullname").val();
        let cemail = $("#cemail").val();
        let message = $("#message").val();

        // Simple validation
        if(!fullname || !cemail || !message){
            $(".alert").removeClass("d-none");
            return false;
        } else {
            $(".alert").addClass("d-none");
        }

        let regex =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if(regex.test(cemail)) {
            $(".alert").addClass("d-none");
        } else {
            $(".alert").removeClass("d-none");
            return false;
        }

        let fd = new FormData();
		fd.append("fullname", fullname);
        fd.append("cemail", cemail);
        fd.append("message", message);

        console.log($("#fullname").val())

        fetch(Env.BASE_API+"/?task=contact-form-email",{
			method: "POST",
			body: fd
		})
			.then(resp=>resp.json())
			.then((data)=>{
				console.log(data)
				if(data.ERR === 0) {

					this.props.history.push({
						pathname: "/contact/ty",
						state: {
							//filename: fn,
							fallback:"/contact"
						}
                    });
					
				} else {
					console.log("API call fail.");
				}
			});
    }

    render () {
        return (
            <form onSubmit={this.sendToApi.bind(this)}>
                <div className="alert alert-warning d-none">Please complete the form with valid email address.</div>
                <div className="form-group">
                    <label htmlFor="fullname">Full Name</label>
                    <input type="text" className="form-control" id="fullname" aria-describedby="fullname" placeholder="Full Name, Juan dela Cruz" name="fullname" />
                    <small id="err-fullname" className="form-text text-muted d-none">Full Name is required</small>
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="text" className="form-control" id="cemail" aria-describedby="email" placeholder="Email, you@email.com" name="cemail" />
                    <small id="err-email" className="form-text text-muted d-none">Email is required</small>
                </div> 
                <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea className="form-control" id="message" rows="3" name="message"></textarea>
                    <small id="err-message" className="form-text text-muted d-none">Please type your message</small>
                </div>
                <button type="submit" className="btn btn-lightblue">Submit</button>
            </form>
        )
    }
}

export default withRouter(ContactForm);


// WEBPACK FOOTER //
// ./src/view/ContactForm.js